export const doesEventMatchSearch = (event: string, search: string) =>
  !search.length || event.toLowerCase().includes(search.toLowerCase());
